<template>
  <el-container class="layout-container">
    <el-aside width="200px" class="sidebar">
      <div class="logo">
        <h2>摄像头管理平台</h2>
      </div>
      <el-menu
        :default-active="activeMenu"
        router
        class="sidebar-menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/organization">
          <el-icon><FolderOpened /></el-icon>
          <span>组织管理</span>
        </el-menu-item>
        <el-menu-item index="/business">
          <el-icon><Briefcase /></el-icon>
          <span>业务管理</span>
        </el-menu-item>
        <el-menu-item index="/device">
          <el-icon><VideoCamera /></el-icon>
          <span>设备管理</span>
        </el-menu-item>
        <el-menu-item index="/preview">
          <el-icon><Monitor /></el-icon>
          <span>实时预览</span>
        </el-menu-item>
        <el-menu-item index="/storage">
          <el-icon><Folder /></el-icon>
          <span>存储配置</span>
        </el-menu-item>
        <el-menu-item index="/annotate">
          <el-icon><EditPen /></el-icon>
          <span>图片标注</span>
        </el-menu-item>
        <el-menu-item index="/local">
          <el-icon><Document /></el-icon>
          <span>本地标注</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="header-title">{{ currentTitle }}</div>
      </el-header>
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'Layout',
  setup() {
    const route = useRoute()
    
    const activeMenu = computed(() => route.path)
    const currentTitle = computed(() => route.meta.title || '摄像头管理平台')
    
    return {
      activeMenu,
      currentTitle
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.sidebar {
  background-color: #304156;
  overflow-y: auto;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #2b3a4a;
  color: #fff;
}

.logo h2 {
  font-size: 18px;
  font-weight: normal;
}

.sidebar-menu {
  border-right: none;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.header-title {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
}

.main-content {
  background-color: #f0f2f5;
  padding: 20px;
}
</style>






